import React from 'react';
import * as yup from 'yup';
import { Formik } from 'formik';
import { useHistory } from 'react-router-dom';
import { StatusCodes } from 'http-status-codes';

import WhitePad from '../../../../components/common/WhitePad/WhitePad';
import CategoriesApi from '../../../../services/api/CategoriesApi';
import FormRow from '../../../../components/common/forms/Row/FormRow';
import TextInputComponent from '../../../../components/common/forms/TextInput/TextInputComponent';
import PrimaryButton from '../../../../components/common/forms/Button/PrimaryButton';
import TitleComponent from '../../../../components/common/forms/Title/TitleComponent';
import FormWrapper from '~/src/components/common/forms/FormWrapper/FormWrapper';

const validationSchema = yup.object().shape({
  name: yup.string().label('Name').min(2, 'Name should be at least 2 symbols').required('Name is required'),
});

export default function CategoryCreate(): JSX.Element {
  const history = useHistory();

  const saveItem = async (values, setSubmitting) => {
    setSubmitting(true);
    const res = await CategoriesApi.create(values);
    if (res.status === StatusCodes.OK) {
      history.push('/categories');
    } else {
      setSubmitting(false);
    }
  };

  return (
    <WhitePad>
      <TitleComponent title="Create Category" onLeftHandler={history.goBack} titleLeft="Back" />
      <FormWrapper>
        <Formik
          initialValues={{
            name: '',
          }}
          validationSchema={validationSchema}
          onSubmit={(values, { setSubmitting }) => saveItem(values, setSubmitting)}
        >
          {({ values, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
            <form onSubmit={handleSubmit} autoComplete="off">
              <FormRow>
                <TextInputComponent
                  label="Name"
                  name="name"
                  value={values.name}
                  onBlur={handleBlur}
                  onChange={handleChange}
                />
              </FormRow>
              <PrimaryButton isSubmitting={isSubmitting} type="submit" title="Save" />
            </form>
          )}
        </Formik>
      </FormWrapper>
    </WhitePad>
  );
}
